import { render } from "./School.vue?vue&type=template&id=262f982c"
import script from "./School.vue?vue&type=script&lang=js"
export * from "./School.vue?vue&type=script&lang=js"
script.render = render

export default script